import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { FormControl, IconButton, TextField } from '@mui/material';
import { AddCircleOutline, RemoveCircleOutline } from '@mui/icons-material';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { getImageById, Product, ProductImage } from 'api';
import { useCallback, useEffect, useState } from 'react';
import { useStyles } from './ProductTile.styles';

type ProductTileProps = Product & {
  quantity?: number;
  onAdd?: Function;
  onRemove?: Function;
}

function ProductTileImage({ image }: { image?: ProductImage }): JSX.Element {
  
  const [imageUrl, setImageUrl] = useState<string | null>(null);
  useEffect(() => {
    if(image) {
    getImageById({ id: image.id, brandId: image.brandId }).then((image) => {
        setImageUrl(image.url);
      });
    }
  }, [image]);

  return (
    <LazyLoadImage
      width={72}
      height={72}
      src={imageUrl || ''}
    />
  );
}

export default function ProductTile(product: ProductTileProps) {
  const { heading, subHeading, image, quantity, onAdd } = product;
  const classes = useStyles();
  const [newQuantity, setNewQuantity] = useState<number>();

  const updateQuantity = useCallback((newQuantity: number) => {
    if (onAdd) {
      onAdd({ ...product, onAdd: undefined }, newQuantity);
    }
  }, [onAdd, product]);

  const onTextInput = useCallback((e) => {
    const value = e.target.value;
    setNewQuantity(value);

    if (value) {
      updateQuantity(parseInt(value, 10));
    }
  }, [updateQuantity]);

  useEffect(() => setNewQuantity(quantity || 0), [quantity]);

  return (
    <Box className={classes.container}>
      <Grid container spacing={2}>
        <Grid item>
          <ProductTileImage image={image} />
        </Grid>
        <Grid item xs container>
          <Grid item xs container direction="column" spacing={2}>
            <Grid item xs>
              <Typography gutterBottom variant="body1" component="div">
                {heading}
              </Typography>
              {subHeading && (
                <Typography variant="body2" gutterBottom>
                  {subHeading}
                </Typography>
              )}
            </Grid>
          </Grid>

          <Grid item className={classes.buttonsContainer}>
            {quantity && onAdd && (
              <IconButton
                className={classes.button}
                onClick={() => updateQuantity(quantity - 1)}>
                <RemoveCircleOutline />
              </IconButton>
            )}
            {quantity && onAdd && (
              <FormControl fullWidth>
                <TextField
                  value={newQuantity}
                  type="number"
                  className={classes.input}
                  onChange={onTextInput}
                  onBlur={(e) => !e.target.value && updateQuantity(0)}
                />
              </FormControl>
            )}
            {onAdd && (
              <IconButton
                className={classes.button}
                onClick={() => updateQuantity((quantity || 0) + 1)}>
                <AddCircleOutline />
              </IconButton>
            )}
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}
